<kendo-dialog *ngIf="active" (close)="closeForm()" [width]="400" [height]="480">
    <kendo-dialog-titlebar>
      {{ isNew ? 'Add new service' : 'Edit service' }}
    </kendo-dialog-titlebar>

    <form novalidate [formGroup]="editForm">
        <div class="form-group">
            <label for="IsLocked" class="control-label">Locked&nbsp;</label>
            <input type="checkbox" kendoCheckBox formControlName="IsLocked" />
        </div>        
        <div class="form-group">
            <label for="Code" class="control-label">Code</label>
            <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="Code" />           
            <div class="k-tooltip-validation tooltip-stacked"
                *ngIf="editForm.controls.Code.invalid && !isNew && !editForm.controls.Code.untouched">
                <div *ngIf="editForm.controls.Code.hasError('required')">
                    <span class="k-icon k-i-warning"></span>
                    Code is required
                </div>
                <div *ngIf="editForm.controls.Code.hasError('minlength')">
                    <span class="k-icon k-i-warning"></span>
                    Code must be at least 3 characters
                </div>
                <div *ngIf="editForm.controls.Code.hasError('maxlength')">
                    <span class="k-icon k-i-warning"></span>
                    Code must not exceed 25 characters
                </div>
                <div *ngIf="editForm.controls.Code.hasError('pattern')">
                    <span class="k-icon k-i-warning"></span>
                    Code must only contain letters, numbers, underscores, dashes, periods
                </div> 
                <div *ngIf="editForm.controls.Code.hasError('unique')">
                    <span class="k-icon k-i-warning"></span>
                    Code is already taken by another service
                </div>                
            </div>
        </div>
        <div class="form-group">
            <label for="Name" class="control-label">Name</label>
            <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="Name" />
            <div class="k-tooltip k-tooltip-validation tooltip-stacked"
                *ngIf="editForm.controls.Name.invalid && !isNew && !editForm.controls.Name.untouched">
                <div *ngIf="editForm.controls.Name.hasError('required')">
                    <span class="k-icon k-i-warning"></span>
                    Name is required
                </div>
                <div *ngIf="editForm.controls.Name.hasError('minlength')">
                    <span class="k-icon k-i-warning"></span>
                    Name must be at least 3 characters
                </div>
                <div *ngIf="editForm.controls.Name.hasError('maxlength')">
                    <span class="k-icon k-i-warning"></span>
                    Name must not exceed 50 characters
                </div>
                <div *ngIf="editForm.controls.Name.hasError('pattern')">
                    <span class="k-icon k-i-warning"></span>
                    Name must only contain letters, numbers, spaces, colons, underscores, dashes, periods
                </div>              
            </div>
        </div>
        <div class="form-group">
            <label for="Description" class="control-label">Description</label>
            <textarea kendoTextArea cols="60" rows="2" class="modal-row-element" formControlName="Description"></textarea>
            <div class="k-tooltip k-tooltip-validation"
                *ngIf="editForm.controls.Description.invalid && !isNew && !editForm.controls.Description.untouched">
                <div class="tooltip-stacked" *ngIf="editForm.controls.Description.hasError('maxlength')">
                    <span class="k-icon k-i-warning"></span>
                    Description must not exceed 200 characters
                </div>
                <div class="tooltip-stacked" *ngIf="editForm.controls.Description.hasError('pattern')">
                    <span class="k-icon k-i-warning"></span>
                    Description must only contain letters, numbers, spaces, colons, semicolons, underscores, dashes, periods, returns
                </div>              
            </div>
        </div>         
    </form>
    
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">Cancel</button>
        <button class="k-button k-primary" [disabled]="!editForm.valid" (click)="onSave($event)">Save</button>
    </kendo-dialog-actions>
</kendo-dialog>
`
